 {
    "common": {
    "thisWeek": "Cette semaine",
    "lastWeek": "La semaine dernière",
    "lastNumberOfDays": "{numberOfDays} derniers jours",
    "thisMonth": "Ce mois-ci"
    },
    "subAccounts": "Sous-comptes",
    "submitFeedback": "Envoyer du feedback",
    "createSubAccount": "Créer un sous-compte",
    "viewScheduleReports": "Afficher les rapports programmés",
    "searchSubAccount": "Rechercher par sous-compte",
    "columns": "Colonnes",
    "sortBy": "Trier par",
    "selectColumns": "Sélectionner des colonnes",
    "maxColumns": "8 colonnes au maximum à une Date",
    "applyColumns": "Appliquer des colonnes",
    "activeUsers": "utilisateurs actifs",
    "appointments": "Rendez-vous",
    "contacts": "Contacts",
    "emails": "Gmail",
    "textMessages": "messages de corps",
    "calls": "appels",
    "submissions": "Envois",
    "reviews": "avis",
    "sitesCreated": "Sites créés",
    "name": "Nom",
    "formSubmissions": "Envois de formulaires",
    "surveySubmissions": "Envois de sondages",
    "facebookFormSubmissions": "Envois de formulaires Facebook",
    "funnels": "entonnoirs",
    "websites": "Sites web",
    "forms": "Formulaires",
    "surveys": "sondages",
    "highestFirst": "maximum d'abord",
    "lowestFirst": "en plus de",
    "orderBy": "essai via",
    "noMoreLocations": "Aucune adresse e-mail n'a été trouvée",
    "preparingReport": "Nous préparons votre rapport…",
    "preparingReportDesc": "Ne fermez pas ou ne rechargez pas cette fenêtre pendant l'exportation.",
    "outOf": "de",
    "subAccountsExported": "Sous-comptes exportés",
    "close": "Fermer",
    "scheduledForDeletion": "programmé pour la suppression",
    "readyToSell": "prêt -vous vendre",
    "closedWon": "Terminé (remporté)",
    "wpSaleSuccessful": "La vente de WordPress est réussie",
    "wpNotSold": "WordPress n'est pas encore livré",
    "yxtSaleSuccessful": "Oui, la vente est réussie",
    "yxtNotSold": "Oui, il n'y a pas encore de vente",
    "saasSubInactive": "L'abonnement SaaS est inactif",
    "saasSubTrialing": "Abonnement SaaS en cours d'essai",
    "saasSubActive": "L'abonnement SaaS est dynamique",
    "emailRebillingActive": "La refacturation des adresses e-mail est dynamique",
    "emailRebillingInactive": "La refacturation par E-mail est inactif",
    "twilioRebillingActive": "La refacturation Twilio est dynamique",
    "twilioRebillingInactive": "La refacturation Twilio est inactif",
    "wpRebillingActive": "La refacturation par WhatsApp est active",
    "wpRebillingInactive": "La refacturation par WhatsApp est inactive",
    "saasModeActivated": "Le mode SaaS est activé",
    "paymentPending": "Le paiement est en attente",
    "saasModeNotActivated": "Le mode SaaS n'est pas activé",
    "managedByLCPhone": "gérer via ACH",
    "migrationToLCPhone": "dans le cadre de la migration vers le Téléphone ACH",
    "notManagedByLCPhone": "Ne pas gérer via ACH",
    "managedByLCEmail": "gérer via LeadConnector Email System",
    "notMangedByLCEmail": "Ne pas gérer LeadConnector Email System",
    "remainingWalletBalance": "Solde restant du portefeuille numérique de cet emplacement SaaS",
    "reports": "Rapports",
    "switchToSubAccount": "Passer au sous-compte",
    "manageClient": "Gérer le client",
    "subAccountDeletedIfChangedMind": "Ce sous-compte sera supprimé le {time}. Si vous avez changé d'avis,",
    "subAccountDeletedInMinute": "Ce sous-compte sera supprimé dans la minute qui suit",
    "changedMind": "si vous êtes dynamique",
    "clickHere": "ici",
    "subAccountPaused": "Ce sous-compte a été mis en pause. Vos clients ne peuvent pas se connecter, mais l'agence peut le faire. Pour réactiver ce compte,",
    "subAccountRestricted": "Ce sous-compte est en pause en raison d'une approbation en attente.",
    "subAccountVerificationPending": "Ce sous-compte est en pause en raison de la vérification en attente de l'adresse e-mail et du numéro de téléphone par l'administrateur du sous-compte.",
    "subAccountDeclined": "Ce sous-compte est suspendu en raison du refus de la demande d'approbation. Vous pouvez toujours réactiver ce sous-compte depuis ",
    "here": "ici.",
    "reviewAndResume": "pour examiner et réactiver ce sous-compte.",
    "incomingCalls": "Appels entrants",
    "outgoingCalls": "Appels sortants",
    "totalTalktime": "Temps de conversation total",
    "incomingEmails": "Gmailentrant",
    "outgoingEmails": "Gmailsortant",
    "incomingSms": "Messages entrants",
    "outgoingSms": "Messages de corps sortants",
    "contactsCreated": "Nombre total de contacts créés",
    "appointmentsBooked": "Nombre total de rendez-vous réservés",
    "totalFormSubmissions": "Nombre total d'envois de formulaires",
    "totalSurveySubmissions": "Nombre total d'envois de sondages",
    "totalFacebookFormSubmissions": "Nombre total d'envois de formulaires Facebook",
    "incomingGMBMessages": "Messages GBP entrants",
    "outgoingGMBMessages": "Messages GBP sortants",
    "gmbMessages": "Messages GBP",
    "fbMessages": "Messages Facebook",
    "incomingFbMessages": "Messages Facebook entrants",
    "outgoingFbMessages": "Messages Facebook sortants",
    "igMessages": "Messages Instagram",
    "incomingIgMessages": "Messages Instagram entrants",
    "outgoingIgMessages": "Messages Instagram sortants",
    "totalReviews": "Nombre total d'avis",
    "positiveReviews": "E-mails actifs",
    "negativeReviews": "évaluations négatives",
    "back": "Retour",
    "selectDashboards": "Sélectionner des tableau de bord",
    "next": "Suivant",
    "backToSubAccounts": "Retour aux sous-comptes",
    "pauseSchedule": "Mettre le calendrier en mettre en pause",
    "resumeSchedule": "Reprendre la planification",
    "editSchedule": "Modifier le programme",
    "addSchedule": "Ajouter un programme",
    "selectReportToAdd": "Rapports à inclure in l'e-mail",
    "selectAll": "chaque",
    "pauseScheduleConfirm": "Voulez-vous vraiment mettre en pause le calendrier du rapport ?",
    "resumeScheduleConfirm": "Êtes-vous sûr de vouloir reprendre la planification du rapport ?",
    "tasks": "Tâches",
    "conversations": "Conversations",
    "users": "utilisateur",
    "dealOverview": "accord sur l'ensemble",
    "confirmAction": "Confirmer l'action",
    "yes": "Oui",
    "no": "Non",
    "reportDetails": "Informations du rapport",
    "reportCreatedOn": "rapport créé",
    "searchByEmail": "Rechercher via adresse e-mail",
    "lastActivity": "Dernière activité",
    "noRecords": "Aucun enregistrement trouvé",
    "scheduleReport": "Programmer un rapport",
    "schedule": "calendrier",
    "save": "Enregistrer",
    "emailSubject": "ligne d'objet",
    "frequency": "fréquence",
    "daily": "Quotidiennement",
    "weekly": "Hebdomadaire",
    "monthly": "Mensuellement",
    "nextScheduleDate": "Date du calendrier Suivant",
    "startingOn": "Démarrage de votre",
    "timeOfDay": "Date de jour",
    "reportsToTimezone": "Le rapport sera envoyé dans le fuseau horaire du sous-compte",
    "selectRecipients": "Sélectionner les destinataires",
    "invalidEmail": "Veuillez saisir une adresse e-mail valide.",
    "testEmail": "E-mail de Test",
    "selectTestRecipients": "destinataires de Test",
    "setupSubject": "configurer le sujet ci-dessus pour Test le rapport",
    "sendTest": "Test",
    "scheduleSimilarSchedules": "Programmez un rapport similaire pour les autres sous-comptes",
    "accountSummary": "Résumé du compte",
    "scheduleList": "Programmer la liste",
    "subAccountName": "Nom du sous-compte",
    "nextRunDate": "Prochaine date d'exécution",
    "reportSectionsAdded": "Sections de rapport ajoutées",
    "status": "Statut",
    "scheduleAction": "Programmer l'action",
    "cancel": "Annuler",
    "pleaseWait": "Chargement…",
    "confirm": "Confirmer",
    "booked": "réservé",
    "confirmed": "Confirmé",
    "showed": "Honoré",
    "noShow": "Non honoré",
    "cancelled": "Annulé",
    "unread": "Non lus",
    "engagement": "engagement",
    "reaction": "réponse",
    "deliverySummary": "Résumé de la livraison",
    "successfulDelivery": "Livraison réussie",
    "opened": "Ouvert",
    "clicked": "Cliqué",
    "replied": "Répondu",
    "unsubscribed": "Désinscrit",
    "complained": "insatisfait",
    "failed": "Échec",
    "bounced": "rejeté",
    "open": "Ouvert",
    "won": "Remporté",
    "abandoned": "Abandonné",
    "lost": "Perdu",
    "sent": "Envoyé",
    "eject": "e-mail",
    "delivered": "Envoyé",
    "faceBookLeadForm": "Formulaire de prospect Facebook",
    "overdue": "En retard",
    "reviewsReceived": "Échec de l'analyse",
    "formBuilders": "Outils de création de formulaires",
    "switchToSaaS": "Passer à SaaS",
    "numberOfContacts": "Nombre total de contacts",
    "numberOfAppointments": "Nombre total de rendez-vous",
    "outreach": "extension",
    "notSubAccountUser": "N'est pas un utilisateur du sous-compte",
    "searchSubAccName": "Rechercher par nom de sous-compte",
    "recipients": "destinataires",
    "scheduleCreated": "Calendrier de rapport par e-mail créé pour ",
    "scheduleUpdated": "Calendrier de rapport par e-mail mis à jour pour ",
    "scheduleNotCreated": "Le calendrier de rapport par e-mail n'a pas pu être créé pour",
    "scheduleNotUpdated": "Le calendrier de rapport par e-mail n'a pas pu être mis à jour pour",
    "total": "Total",
    "inbound": "entrant",
    "outbound": "sortant",
    "totalEmails": "Nombre total d'e-mails",
    "inboundEmails": "E-mails entrants",
    "outboundEmails": "E-mails sortants",
    "totalTextMessages": "Total des messages texte",
    "inboundTextMessages": "Messages texte entrants",
    "outboundTextMessages": "Messages texte sortants",
    "totalCalls": "Somme des appels",
    "inboundCalls": "Appels entrants",
    "outboundCalls": "Appels sortants",
    "faceBookLeadFormSubmissions": "Envois de formulaires de contact Facebook",
    "inboundGMBMessages": "Messages GBP entrants",
    "outboundGMBMessages": "Messages GBP sortants",
    "totalIgMessages": "Total des messages Instagram",
    "inboundIgMessages": "Messages Instagram entrants",
    "outboundIgMessages": "Messages Instagram sortants",
    "totalfbMessages": "Nombre total de messages Facebook",
    "inboundfbMessages": "Messages Facebook entrants",
    "outboundfbMessages": "Messages Facebook sortants",
    "sitesCreatedFunnels": "Sites créés - entonnoirs",
    "sitesCreatedActiveFunnels": "Sites créés - entonnoirs actifs",
    "sitesCreatedWebsites": "Sites créés - sites Web",
    "sitesCreatedActiveWebsites": "Sites créés - sites Web actifs",
    "sitesCreatedForms": "Sites créés - formulaires",
    "sitesCreatedActiveForms": "Sites créés - formulaires actifs",
    "sitesCreatedSurveys": "Sites créés - sondages",
    "sitesCreatedActiveSurveys": "Sites créés – Sondages actifs",
    "googleReviews": "Avis Google",
    "facebookReviews": "Avis Facebook",
    "inboundCallDuration": "Durée des appels entrants (heures)",
    "outboundCallDuration": "Durée des appels sortants (heures)",
    "pleaseSelect": "Sélectionner",
    "subAccountIsDeleted": "Ce sous-compte a été supprimé",
    "subAccountIsPaused": "Ce sous-compte a été mis en pause",
    "success": "Bravo",
    "error": "Erreur",
    "testEmailSent": "E-mail de Test envoyé",
    "testEmailNotSent": "E-mail de Test n'a pas pu être envoyé",
    "reviewRequest": "Demande d'avis",
    "pendingTransferDescription": "D'autres agences ont demandé de vous transférer des sous-comptes.",
    "pendingTransferHeading": "Vous avez des demandes de transfert de sous-compte en attente.",
    "subAccountTransfer": "Transferts de sous-compte",
    "manageSubAccTransfer": "Gérez vos demandes de transfert de sous-comptes.",
    "subAccRequest": "Demandes de sous-compte {tabName}",
    "receive": "hériter",
    "send": "Envoyer",
    "release": "version",
    "requests": "{count} demandes",
    "subAccLimit": "La limite d'utilisation des sous-comptes a été atteinte.",
    "subAccPlanLimit": "Vous avez utilisé 3 sous-comptes autorisés sur 3 dans votre forfait actuel.",
    "upgradeTime": "Il est temps d'effectuer une mise à niveau !",
    "upgradeHigher": "Passez à un forfait supérieur pour accepter le transfert de sous-compte.",
    "browse": "Parcourir les forfaits",
    "pendingTransferTitle": "Une demande de transfert pour ce sous-compte est déjà en attente.",
    "unableTransfer": "Impossible de transférer le sous-compte dans cette agence.",
    "unableEjectCancel": "Impossible d'annuler la demande de retrait du sous-compte.",
    "EjectErrorDetails": "La demande de retrait du sous-compte ne peut pas être annulée.",
    "hippaErrorDescription": "Ce sous-compte est conforme à la loi HIPAA et ne peut pas être transféré vers une agence non conforme à la loi HIPAA.",
    "pendingTransferErrorDescription": "Veuillez annuler la demande de transfert existante pour ce sous-compte avant d’en créer une nouvelle.",
    "receivingAgency": "Agence destinataire",
    "releasingAgency": "Agence émettrice",
    "noOfContacts": "Nombre total de contacts",
    "requestedDate": "Date de la demande",
    "action": "Action",
    "cancelTransfer": "Annuler le transfert",
    "decline": "refusé",
    "cancelTransferRequest": "Voulez-vous annuler la demande de transfert du sous-compte ?",
    "cancelEjectRequest": "Voulez-vous annuler la demande de retrait du sous-compte ?",
    "cancelRequestDescription": "L'agence destinataire ne verra plus cette demande de transfert, et le sous-compte {name} ne sera pas transféré.",
    "cancelEjectRequestDescription": "L'utilisateur sélectionné ne pourra plus créer de nouvelle agence à partir du sous-compte {name}.",
    "declineRequest": "Voulez-vous refuser la demande de transfert du sous-compte ?",
    "declineRequestDescription": "La demande sera refusée et le sous-compte {name} ne sera pas transféré vers votre agence.",
    "approveTransfer": "Voulez-vous approuver le transfert du sous-compte vers votre agence ?",
    "approveTransferDescription": "Le sous-compte {name} sera transféré vers votre agence.",
    "transferNow": "Transférer",
    "cancelNow": "Annuler",
    "transferErrorDetails": "Ce sous-compte ne peut pas être transféré.",
    "cancelRequest": "Annuler la demande",
    "received": "reçu",
    "approve": "approuver",
    "goBack": "Revenir en arrière",
    "done": "Terminé",
    "subAccountTransferred": "Le sous-compte a été transféré !",
    "subAccountTransferDescription": "Même si le sous-compte a été transféré, certains actifs tels que les utilisateurs, les numéros de téléphone, les comptes Mailgun, les listes Yext (etc.) peuvent encore prendre de 10 à 15 minutes pour apparaître dans la destination.",
    "activeSubscriptionsAlert": "L'emplacement a un abonnement dynamique. Veuillez annuler chaque abonnement avant le transfert vers l'emplacement. Liste des abonnements dynamiques : {subscriptions}",
    "isSaasEnabled": "Mode SaaS activé",
    "typeToSearch": "Saisissez votre terme pour rechercher",
    "dateAdded": "Date d'ajout",
    "emailEngagement": "Engagement par e-mail",
    "emailReaction": "Réaction par e-mail",
    "emailDeliverySummary": "Récapitulatif de la livraison des e-mails",
    "facebook": "Facebook",
    "sms": "SMS",
    "instagram": "Instagram",
    "accountSummarySubAccount": "Résumé du compte - {subAccountName}",
    "test": "Test",
    "scheduleExists": "Un programme existe déjà",
    "aToZ": "a - z",
    "zToA": "Zo",
    "onlyAdminUsersCanAddNewSubAccounts": "Seuls les utilisateurs avec le statut d'administrateur peuvent ajouter de nouveaux sous-comptes.",
    "locationName": "Nom de l'emplacement",
    "transferCompleted": "La demande de transfert pour cet emplacement a déjà été traitée. Actualisez la page.",
    "unauthorizedTransfer": "Vous n'avez pas l'autorisation de réaliser cette Action. Seuls les propriétaires d'agence peuvent effectuer cette Action.",
    "bulkLocationTransfer": "Transférer en masse les sous-comptes",
    "singleRequest": "Requête unique",
    "bulkRequest": "Demande en masse",
    "backToLocationTransfer": "Retour à l'emplacement de transfert",
    "initiateBulkTransfer": "Initier un transfert en masse de sous-comptes",
    "initiateBulkTransferDescription": "Sélectionnez les sous-comptes que vous souhaitez transférer, ou saisissez leurs ID séparés par des virgules.",
    "subAccountId": "ID de sous-compte",
    "selectFromList": "Sélectionnez dans la liste",
    "addManually": "Ajouter manuellement",
    "accountsSelected": "{count} sélectionné(s)",
    "selectAllSubAccounts": "chaque",
    "removeAll": "Supprimer tout",
    "addManualLocations": "Ajoutez des ID d'emplacements séparés par des virgules",
    "manualAllLocationIds": "ID d'emplacement du sous-compte que vous souhaitez transmettre, transmettre via coms.",
    "enterLocationIds": "Saisissez les ID d'emplacement",
    "selectSubAccounts": "Sélectionnez les sous-comptes et transférez-les vers une agence existante.",
    "subAccountTransferWarning": "chaque sous-compte des actifs et des utilisateurs obtenir des téléchargements.",
    "proceed": "poursuivre",
    "bulkRequestSubmitted": "Demande de transfert en masse soumise",
    "bulkRequestSubmittedDescription": "Chaque sous-compte sera transféré une fois que l'agence réceptrice aura accepté la demande de transfert. Vous pouvez suivre le statut de la demande sur la page « {pagename} » (selon éligibilité).",
    "bulkTransferRequestFailed": "Échec de la demande de transfert en masse",
    "errorLocations": "Sous-comptes avec erreur",
    "viewDetails": "Afficher les détails",
    "somethingWrong": "Une erreur s'est produite. Veuillez réessayer.",
    "confirmBulkRequest": "Confirmez-vous la demande de transfert en masse ?",
    "bulkTransferAccounts": "Voulez-vous transférer en masse les « {count} » sous-comptes sélectionnés ?",
    "confirmDetails": "Veuillez confirmer les détails avant de transférer.",
    "transferConsent": "J'ai lire et comprendre le guide et le consentement ci-dessus pour chaque limite.",
    "transferInfo": "Le transfert du sous-compte est sujet à l'acceptation par l'agence destinataire dans son compte.",
    "receivingRelNo": "Numéro de relation de l'agence réceptrice",
    "enterRelNo": "Saisissez le numéro de relation",
    "transferConfirmation": "Lors de la réalisation de cette Action, l'envoi en masse des demandes sera envoyé à l'agence refusée ({ relNo }). sous-compte de vous Veuillez noter que cette Action est irréversible pour chaque sous-compte inclus in le traitement.",
    "confirmPassword": "Confirmez en entrant password sous",
    "enterPassword": "Saisissez le mot de passe",
    "requestTransfer": "Demander un transfert",
    "confirmTransfer": "Confirmer le transfert",
    "notNow": "Pas maintenant",
    "invalidRelNo": "Numéro de relation non valide",
    "invalidPassword": "password non valide.",
    "searchSubAccounts": "Rechercher des sous-comptes",
    "searchSubAccountsId": "Rechercher un ID de sous-compte",
    "takeAction": "Prendre des mesures",
    "sub_account_details": "Détails du sous-compte :",
    "no_of_contacts": "Nombre total de contacts",
    "transfer_status": "Statut du transfert",
    "error_info": "Informations sur l'erreur",
    "bulk_transfer_status": "Statut du transfert en masse des sous-comptes",
    "pending": "En attente",
    "processed": "Traité",
    "reject_all": "Rejeter tout",
    "accept_all": "Tout accepter",
    "cancel_all": "Annuler tout",
    "clearAll": "Effacer tout",
    "refresh": "actualiser",
    "rejected": "refusé",
    "decline_transfer": "Refuser le transfert",
    "decline_bulk_transfer": "Voulez-vous refuser la demande de transfert en masse de sous-comptes ?",
    "decline_bulk_transfer_description": "La demande sera refusée et le sous-compte {length} ne sera pas transféré vers votre agence.",
    "accept_bulk_transfer": "Acceptez-vous la demande de transfert en masse de sous-comptes ?",
    "accept_bulk_transfer_description": "La demande sera acceptée et le sous-compte {length} sera transféré vers votre agence.",
    "cancel_bulk_transfer": "Annuler le transfert en masse ?",
    "cancel_bulk_transfer_description": "Voulez-vous vraiment annuler ce transfert en masse de {length} sous-comptes vers « {name} » ?",
    "consent_sub_account_transfer": "Veuillez lire et Consentement à {link}",
    "sub_account_transfer_guidelines": "Directives pour le transfert de sous-comptes",
    "valid_rel": "Saisissez un nombre de lien valide",
    "something_went_wrong": "Une erreur s'est produite. Veuillez réessayer.",
    "export": "Exporter",
    "export_success": "Les données que vous avez demandées sont en cours de traitement. Vous transmettrez un e-mail avec les données in une Date.",
    "export_failed": "Les données que vous avez demandées n'ont pas pu être traitée. Veuillez réessayer plus tard.",
    "selectAllError": "Vous ne pouvez sélectionner que 1 000 sous-comptes à la fois.",
    "max1000": "(Maximum 1 000)",
    "subAccountCount": "Nombre de sous-comptes",
    "whatsapp": "WhatsApp",
    "scheduleBulkPauseConfirm": "Voulez-vous vraiment mettre en pause les rapports {count} ?",
    "scheduleBulkResumeConfirm": "Êtes-vous sûr de vouloir reprendre {count} rapports ?",
    "resume": "Reprendre",
    "pause": "Mettre en pause",
    "resumeSelected": "Reprendre la sélection",
    "pauseSelected": "mettre en pause",
    "bulkActions": "Bulk actions",
    "xReportsSelected": "{count} rapports sélectionnés",
    "selectAllXReports": "Sélectionner tous les {count} rapports",
    "scheduleStatus": "Statut du programme",
    "scheduleSearchPlaceholder": "Rechercher par adresse e-mail ou nom d'emplacement",
    "subAccountsPerPage": "Sous-comptes par page",
    "previous": "Précédent",
    "scheduleBulkAction": "Planifier une action en masse",
    "all": "Tout",
    "active": "Actif",
    "paused": "En pause",
    "scheduleUpdatedSuccessfully": "Calendrier mis à jour avec succès",
    "saveChanges": "Enregistrer les modifications",
    "pauseSchedulesTitle": "mettre en pause les rapports Activer",
    "pauseSchedulesDescription": "rapport pour mettre en pause les rapports actifs.",
    "pauseSchedulesAlert": "Cela affectera uniquement les comptes qui sont dynamiques.",
    "pauseAllSchedulesBtnText": "Mettre en pause tous les rapports programmés",
    "autoScheduleTitle": "Programmation automatique pour les nouveaux comptes",
    "autoScheduleLabel": "Créez automatiquement des rapports programmés lorsqu'un nouveau sous-compte est ajouté.",
    "autoScheduleAlert": "Si vous souhaitez configurer manuellement votre nouveau compte.",
    "autoScheduleEnabledForNewAccounts": "programmation automatique pour les nouveaux utilisateurs",
    "autoScheduleDisabledForNewAccounts": "programmation automatique",
    "deleted": "Supprimé",
    "locationPaused": "Emplacement en pause",
    "scheduleSettingsModalTitle": "Paramètres du rapport sur calendrier",
    "selectAllSchedules": "programmer",
    "selectScheduleForLocation": "Sélectionner un calendrier pour {location}",
    "openSettings": "ouvrir les paramètres",
    "resumeScheduleForLocation": "Reprendre le calendrier pour {location}",
    "pauseScheduleForLocation": "Mettre le calendrier en mettre en pause pour {location}",
    "actions": "Actions",
    "deselectAll": "Désélectionner chaque",
    "scheduleBulkActionResumeSuccess": "en masse activation in cours",
    "scheduleBulkActionPauseSuccess": "Mise en pause des rapports. Veuillez attendre avant de prendre des mesures.",
    "bulkActionCreationError": "Une autre action en masse est en cours. Veuillez réessayer dans un instant.",
    "bulkActionInProgress": "en masse Action déjà in cours",
    "scheduledReports": "Rapports programmé",
    "scheduleBulkActionCompleted": "dans Action en masse",
    "pauseAllSchedulesModalTitle": "Mettre les rapports en pause ?",
    "pauseAllSchedulesModalText": "Cela mettra en pause tous les rapports programmés actifs dans tous les sous-comptes.",
    "addLocationIdsPlaceholder": "Ajoutez les ID d'emplacement que vous souhaitez transférer...",
    "helloWorld": {
      "count": "Le nombre est {count}",
      "editIntro": "Modifier",
      "editAction": "Pour tester le HMR",
      "checkOut": "Vérifiez",
      "officialStarter": ", le starter officiel Vue + Vite",
      "install": "Installer",
      "installDescription": "Dans votre IDE pour une meilleure expérience de développement",
      "learnMore": "Cliquez sur les logos Vite et Vue pour en savoir plus."
    },
    "home": {
      "testMessage": "Bonjour ! Ceci est la page d'accueil de test !"
    },
    "reports": {
      "incoming": "Entrant",
      "outgoing": "Sortant",
      "duration": "Durée",
      "contactsCount": "Nombre total de contacts",
      "appointmentsCount": "Nombre total de rendez-vous",
      "formSubmissions": "Envois de formulaires",
      "surveySubmissions": "Envois de sondages",
      "facebookFormSubmissions": "Envois de formulaires Facebook",
      "funnels": "Entonnoirs",
      "websites": "Sites web",
      "forms": "Formulaires",
      "surveys": "Sondages",
      "gbpMessages": "Messages GBP",
      "facebookMessages": "Messages Facebook",
      "instagramMessages": "Messages Instagram",
      "reviews": "Avis",
      "positives": "Points positifs",
      "negatives": "Négatifs"
    },
    "timeOptions": {
      "00": "00 h 00",
      "01": "01 h 00",
      "02": "02 h 00",
      "03": "03 h 00",
      "04": "04 h 00",
      "05": "05 h 00",
      "06": "06 h 00",
      "07": "07 h 00",
      "08": "08 h 00",
      "09": "09 h 00",
      "10": "10 h 00",
      "11": "11 h 00",
      "12": "12 h 00",
      "13": "13 h 00",
      "14": "14 h 00",
      "15": "15 h 00",
      "16": "16 h 00",
      "17": "17 h 00",
      "18": "18 h 00",
      "19": "19 h 00",
      "20": "20 h 00",
      "21": "21 h 00",
      "22": "22 h 00",
      "23": "23 h 00"
    },
    "transferStatus": {
      "pending": "En attente",
      "processed": "Traité",
      "canceled": "Annulé",
      "cancelled": "Annulé",
      "completed": "Terminé",
      "rejected": "Rejeté",
      "failed": "Échec",
      "payment_pending": "Paiement en attente"
    }
    }
